import * as T from 'three';

/** Additive recoil, never camera/ballistic error. Exact critically damped spring
 * has a quick shoulder impulse and a soft recovery, even at variable frame rates.
 * Burst impulses are bounded so rapid fire cannot fold the character backward. */
export class ShotRecoil {
  amount=0;
  private velocity=0;
  private side=1;
  private recovery=24;
  private readonly axis=new T.Vector3();
  private readonly local=new T.Vector3();
  private readonly q=new T.Quaternion();
  reset():void {this.amount=this.velocity=0;}
  fire(rapid=false,strength=1,recovery=24):void {
    this.recovery=Math.max(1,recovery);
    this.velocity=Math.min(4.5,this.velocity+(rapid?1.45:3.8)*Math.max(0,strength));
    this.side=-this.side;
  }
  apply(dt:number,group:T.Object3D,bones:ReadonlyMap<string,T.Bone>):void {
    const t=Math.min(.1,Math.max(0,dt)),omega=this.recovery;
    const c=this.velocity+omega*this.amount,e=Math.exp(-omega*t);
    this.amount=(this.amount+c*t)*e;
    this.velocity=(this.velocity-omega*c*t)*e;
    if(this.amount<1e-5)return;
    // Recoil after the aim solves, which would otherwise cancel it. Counter
    // the arms below so the gun shifts back while its bore retains its heading.
    group.updateWorldMatrix(true,true);
    group.getWorldQuaternion(this.q);
    this.axis.set(1,this.side*.12,0).normalize().applyQuaternion(this.q);
    for(const [name,weight] of [['spine_01',.32],['spine_02',.43],['spine_03',.25]] as const){
      const bone=bones.get(name);if(!bone?.parent)continue;
      bone.parent.getWorldQuaternion(this.q);
      this.local.copy(this.axis).applyQuaternion(this.q.invert());
      this.q.setFromAxisAngle(this.local,Math.min(.095,this.amount)*weight);
      bone.quaternion.premultiply(this.q);bone.updateWorldMatrix(false,true);
    }
    for(const name of ['upperarm_l','upperarm_r']){
      const bone=bones.get(name);if(!bone?.parent)continue;
      bone.parent.getWorldQuaternion(this.q);
      this.local.copy(this.axis).applyQuaternion(this.q.invert());
      this.q.setFromAxisAngle(this.local,-Math.min(.095,this.amount));
      bone.quaternion.premultiply(this.q);bone.updateWorldMatrix(false,true);
    }
  }
}
